import { FilesManagerComponent } from './FilesManager.component';
import { enhance } from './FilesManager.enhancers';

export const FilesManager = enhance(FilesManagerComponent);
